import clsx from "clsx";
import { MAP_BODY_NAME_TO_STYLE } from "../../Typography/Body/helpers";
import { BodyName } from "../../Typography/Body/types";

export const getInputStyle = (
  hasError: boolean,
  hasValue: boolean,
  isDisabled?: boolean,
) => {
  if (isDisabled) return clsx(defaultInputStyles, disabledInputStyles);
  if (hasError) return clsx(errorInputStyles, defaultInputStyles);
  if (hasValue)
    return clsx(
      defaultInputStyles,
      activeHoverStyles(hasValue),
      inputHasValueStyles,
    );
  return clsx(
    defaultInputStyles,
    activeHoverStyles(hasValue),
    inActiveInputStyles,
  );
};

export const inActiveInputStyles = clsx(
  "border-gray-350 text-gray-350 bg-gray",
);

export const defaultInputStyles = clsx(
  "font-helvetica-mono",
  MAP_BODY_NAME_TO_STYLE[BodyName.Body_4],
  "h-16 w-12 pt-1 md:h-20 md:w-[72px] rounded-md",
  "text-center border",
);

export const errorInputStyles = clsx("border-red-400 text-white bg-gray-950");

export const disabledInputStyles = clsx(
  "text-gray-350 border-gray-500 bg-gray-800",
);

export const inputHasValueStyles = clsx("border-white text-white");

export const activeHoverStyles = (hasValue: boolean) =>
  clsx(
    "betterhover:hover:border-green-500 focus-visible:border-green-500 focus:border-green-500 active:border-green-500 bg-gray-900",
    hasValue
      ? "focus:text-green-500  betterhover:hover:text-green-500  focus:text-green-500  active:text-green-500"
      : "focus:text-gray-350 active:text-gray-350 betterhover:hover:text-gray-350",
    "outline-none",
  );
